// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"215":"48af9fd6","266":"7bdca712","439":"5fe6edd1","640":"4aafdcf4","917":"aba2ce85"}[chunkId] + ".css";
};